<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if=" isShowingChildren(item.children, item)">
      <router-link :to="resolvePath(onlyOneMenu.path)">
        <el-menu-item :index="resolvePath(onlyOneMenu.path)">
          <i
            v-if="onlyOneMenu.meta && onlyOneMenu.meta.icon"
            class="iconfont"
            :class="onlyOneMenu.meta.icon"
          ></i>
          <span
            slot="title"
            v-if="onlyOneMenu.meta && onlyOneMenu.meta.title"
          >{{ onlyOneMenu.meta.title }}</span>
        </el-menu-item>
      </router-link>
    </template>
    <el-submenu v-else :index="resolvePath(item.path)">
      <template slot="title">
        <i
          v-if="item.meta && item.meta.icon"
          class="iconfont"
          :class="item.meta.icon"
        ></i>
        <span v-if="item.meta && item.meta.title">{{ item.meta.title }}</span>
      </template>
      <item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path';

export default {
  name: 'Item',
  data() {
    this.onlyOneMenu = null;
    return {};
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  methods: {
    isShowingChildren(children = [], parent) {
      // 先判断父级 hideChildrenInMenu 是否为 true
      if (parent.hideChildrenInMenu) {
        this.onlyOneMenu = { ...parent, path: '' };
        return true;
      }

      // 若 hideChildrenInMenu 为 false，则过滤子集
      const passChildren = children.filter((item) => {
        if (item.hidden) {
          return false;
        }
        return true;
      });

      if (passChildren.length === 0) {
        this.onlyOneMenu = { ...parent, path: '' };
        return true;
      }
      return false;
    },
    resolvePath(routePath) {
      return path.resolve(this.basePath, routePath);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/variables'
el-submenu-title-style()
  color #ffffff !important
  i, span
    color $menuActiveText !important
el-submenu-title-line()
  content ''
  position absolute
  left 0
  width 2px
  height 100%
  background-color $theme
.menu-wrapper
  .iconfont
    margin-right 10px
    font-size 20px
  >>>.el-submenu__title
    position relative
    height 40px
    line-height 40px
    i
      color $menuText
    &:focus, &:hover
      el-submenu-title-style()
      &::before
        el-submenu-title-line()
  >>>.el-submenu__icon-arrow
    right 32px
  .el-menu-item
    height 40px
    line-height 40px
    i
      color $menuText
    &:focus, &:hover, &.is-active
      color $menuActiveText !important
    &.is-active
      background-color $theme !important
      i
        color $menuActiveText
  .el-submenu.is-active
    >>>.el-submenu__title
      el-submenu-title-style()
      &::before
        el-submenu-title-line()
</style>
